import { createAsyncThunk } from "@reduxjs/toolkit";
import ReportApi from "api/ReportApi";
import CreateCastReportReq from "types/req/castReport/CreateCastReportReq";

export const postReport = createAsyncThunk(
  "postReport",
  ({ companyId, req }: { companyId: number; req: CreateCastReportReq }) =>
    ReportApi.create(companyId, req)
);
